import { authToken } from './api';
import type { EmbedMessage, ToolId } from '../types';

const configuredOrigins = (import.meta.env.VITE_EMBED_PARENT_ORIGINS || 'https://robrion.net,https://www.robrion.net,http://localhost:3000')
  .split(',')
  .map((origin: string) => origin.trim())
  .filter(Boolean);

export const isEmbedded = (): boolean => {
  try { return window.self !== window.top; } catch { return true; }
};

export const isAllowedParentOrigin = (origin: string): boolean => configuredOrigins.includes(origin);

type ParentMessage = { type: 'AIO_READY' } | { type: 'AIO_REQUEST_AUTH' };

let trustedParentOrigin: string | undefined;

export function sendToParent(message: ParentMessage): void {
  if (!isEmbedded() || !window.parent) return;
  const targetOrigin = trustedParentOrigin || configuredOrigins[0];
  if (!targetOrigin) return;
  window.parent.postMessage({ source: 'aio-devops-tools', ...message }, targetOrigin);
}

export function listenForParentMessages(onNavigate: (toolId: ToolId) => void, onAuthenticated: (token: string) => void): () => void {
  const handler = (event: MessageEvent<EmbedMessage | { source: string; type: string }>) => {
    if (!isAllowedParentOrigin(event.origin) || event.source !== window.parent) return;
    trustedParentOrigin = event.origin;
    const message = event.data;
    if (!message || message.source !== 'robrion') return;
    if (message.type === 'AIO_AUTH_TOKEN' && 'token' in message && typeof message.token === 'string' && message.token) {
      authToken.set(message.token);
      onAuthenticated(message.token);
    }
    if (message.type === 'AIO_NAVIGATE' && 'toolId' in message && typeof message.toolId === 'string') onNavigate(message.toolId as ToolId);
  };
  window.addEventListener('message', handler);
  sendToParent({ type: 'AIO_READY' });
  return () => window.removeEventListener('message', handler);
}

export function requestParentAuth(): void {
  sendToParent({ type: 'AIO_REQUEST_AUTH' });
}
